import { useMemo } from 'react';
import { SearchableSelect } from '@/components/ui/SearchableSelect';
import { useCustomerOptions } from '@/hooks/useCustomerOptions';
import type { CustomerResponse } from '@/types/customer';

export interface CustomerSelectProps {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  onCustomerChange?: (customer: CustomerResponse | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  required?: boolean;
  error?: string;
  showDetails?: boolean;
  name?: string;
}

export function CustomerSelect({
  label = 'Customer',
  value = '',
  onChange,
  onCustomerChange,
  placeholder = 'Select customer',
  disabled,
  className,
  required,
  error,
  showDetails = true,
  name,
}: CustomerSelectProps) {
  const { options, loading, getCustomer } = useCustomerOptions();

  const selected = useMemo(() => (value ? getCustomer(value) : null), [getCustomer, value]);

  const handleChange = (next: string) => {
    onChange?.(next);
    onCustomerChange?.(next ? getCustomer(next) ?? null : null);
  };

  return (
    <div className={className}>
      <SearchableSelect
        label={label}
        name={name}
        required={required}
        error={error}
        value={value}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        disabled={disabled}
        loading={loading}
        searchPlaceholder="Search customers…"
        emptyMessage="No customers found"
      />
      {showDetails && selected && (
        <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
          {[selected.phone, selected.email].filter(Boolean).join(' · ') || `ID ${selected.id}`}
        </p>
      )}
    </div>
  );
}
